module.exports = __webpack_public_path__ + "static/media/ADAC.f6eef4fe.svg";